import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-800" }
const _hoisted_3 = { class: "flex items-center space-x-4" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-4 md:grid-cols-4" }
const _hoisted_5 = { class: "flex flex-col justify-end pb-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiTextInput = _resolveComponent("UiTextInput")!
  const _component_UiCheckboxInput = _resolveComponent("UiCheckboxInput")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiCheckDirtyBeforeRouteLeave = _resolveComponent("UiCheckDirtyBeforeRouteLeave")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "space-y-4",
      autocomplete: "off",
      onSubmit: _withModifiers($setup.onSubmit, ["prevent"])
    }, [
      _createVNode(_component_UiPageHeader, null, {
        info: _withCtx(() => [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('connectFlow.' + $setup.props.action + '.title')), 1 /* TEXT */)
        ]),
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListConnectFlow' } }),
            (
                                ($setup.props.action == $setup.FormAction.CREATE &&
                                    _ctx.$can($setup.Permission.CREATE_CONNECT_FLOW)) ||
                                ($setup.props.action == $setup.FormAction.EDIT &&
                                    _ctx.$can($setup.Permission.EDIT_CONNECT_FLOW))
                            )
              ? (_openBlock(), _createBlock(_component_UiButton, {
                  key: 0,
                  type: "submit",
                  variant: "primary",
                  "text-variant": "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Save')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_UiPanel, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_UiTextInput, {
              modelValue: $setup.v$.name.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.name.$model) = $event)),
              name: "name",
              type: "text",
              label: _ctx.$t('connectFlow.labels.name'),
              errors: $setup.v$.name.$errors,
              required: $setup.v$.name.required !== undefined,
              onBlur: $setup.v$.name.$touch
            }, null, 8 /* PROPS */, ["modelValue", "label", "errors", "required", "onBlur"]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_UiCheckboxInput, {
                modelValue: $setup.v$.isActive.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.v$.isActive.$model) = $event)),
                name: "isActive",
                label: _ctx.$t('connectFlow.labels.isActive')
              }, null, 8 /* PROPS */, ["modelValue", "label"])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ], 32 /* NEED_HYDRATION */),
    _createVNode(_component_UiCheckDirtyBeforeRouteLeave, {
      dirty: $setup.v$.$anyDirty
    }, null, 8 /* PROPS */, ["dirty"])
  ]))
}